<div class="filter">
  <div
    *ngIf="filterStatuses"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'statuses'"
      [filter]="filterStatuses">
    </app-filter-select>
  </div>

  <div
    *ngIf="priorityStatuses"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'PRIORITY' | translate"
      [filter]="priorityStatuses">
    </app-filter-select>
  </div>
  <div class="filter__item">
    <app-period
      [filterStart]="filterStart"
      [filterEnd]="filterEnd"
      title="{{ 'FILTERS.PERIOD' | translate }}">
    </app-period>
  </div>
</div>
